import { ReactElement } from 'react'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Stack, Typography } from '@mui/material'
import { AnsweredQuestion } from '../utils'

interface Props {
  question: AnsweredQuestion
}

/** A question of the agent in the chat history and what the user answered (`answeredQuestionOf`). */
const AnsweredQuestionSummary = ({ question }: Props): ReactElement => {
  const answer = [...question.answer, question.comment].filter(Boolean).join(', ')

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={0.75}
      sx={{ border: 1, borderColor: 'divider', borderRadius: 1, px: 1, py: 0.5, my: 0.5 }}
      data-cy="ai-chat-answered-question"
    >
      <HelpOutlineIcon fontSize="small" sx={{ color: 'text.secondary', mt: '1px' }} />
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2">{question.question}</Typography>
        <Typography variant="caption" color="text.secondary">
          {answer || 'Nicht beantwortet'}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default AnsweredQuestionSummary
